const isLoggedIn = state => (state.authToken === '') ? false : true;

export default isLoggedIn;
